<script setup lang="ts">
const { t, locale } = useI18n()

useHead({
  htmlAttrs: {
    lang: () => (locale.value === 'en' ? 'en-US' : 'zh-CN'),
  },
  meta: [
    { name: 'description', content: () => t('meta.description') },
    { name: 'keywords', content: () => t('meta.keywords') },
  ],
})
</script>

<template>
  <NuxtLayout>
    <!-- Remount page on locale change so all page copy refreshes with language switch -->
    <NuxtPage :key="locale" />
  </NuxtLayout>
</template>
